import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CancelIcon from "@mui/icons-material/Cancel";

const FreeToExecuteFilter = ({
  keysWithOperators,
  setKeysWithOperators,
  setCurrentPage,
}) => {
  const forPaidOnlyFilter = keysWithOperators.find(
    (filter) => filter.key === "forPaidOnly"
  );
  const selectedValue = forPaidOnlyFilter
    ? forPaidOnlyFilter.searchTerm === "false"
      ? "Free"
      : "Premium"
    : "";

  const handleChange = (event) => {
    const value = event.target.value;
    setCurrentPage(1);

    if (value === "") {
      // Remove forPaidOnly filter
      setKeysWithOperators((prev) =>
        prev.filter((filter) => filter.key !== "forPaidOnly")
      );
    } else {
      // Add or update forPaidOnly filter
      const newFilter = {
        key: "forPaidOnly",
        operator: "equals",
        searchTerm: value === "Free" ? "false" : "true",
      };
      setKeysWithOperators((prev) => {
        const otherFilters = prev.filter(
          (filter) => filter.key !== "forPaidOnly"
        );
        return [...otherFilters, newFilter];
      });
    }
  };

  const handleClearFilter = () => {
    setCurrentPage(1);
    setKeysWithOperators((prev) =>
      prev.filter((filter) => filter.key !== "forPaidOnly")
    );
  };

  const tooltipTitle =
    selectedValue === "Free"
      ? "Showing problems that are free to execute"
      : selectedValue === "Premium"
      ? "Showing problems that require a premium plan to execute"
      : "Filter problems by (free or premium)";

  return (
    <Tooltip title={tooltipTitle} placement="top" arrow>
      <FormControl
        sx={{
          m: 0.5,
          "& .MuiOutlinedInput-root": { borderRadius: "16px" },
          width: 140,
        }}
        size="small"
      >
        <Select
          value={selectedValue}
          onChange={handleChange}
          displayEmpty
          renderValue={(selected) =>
            selected ? `${selected}` : <span>Free to execute</span>
          }
          MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
          {...(selectedValue && {
            sx: {
              "& .MuiSelect-icon": { right: 0 },
              "& .MuiSelect-select": {
                paddingRight: "0px !important",
              },
            },
          })}
          input={
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  <LockOpenIcon sx={{ fontSize: "medium" }} />
                </InputAdornment>
              }
            />
          }
          endAdornment={
            selectedValue && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Clear free to execute filter"
                  onClick={handleClearFilter}
                  size="small"
                  color="error"
                >
                  <CancelIcon sx={{ fontSize: "medium" }} />
                </IconButton>
              </InputAdornment>
            )
          }
        >
          <MenuItem value="Free">Free</MenuItem>
          <MenuItem value="Premium">Premium</MenuItem>
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default FreeToExecuteFilter;
